module.exports = __webpack_public_path__ + "img/bgd2.be0a461c.svg";